import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/read-record/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ReadRecordFeature } from '@framework/workbench/ui/read-record/read-record-feature';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Controller({ menuItems: MENU_CONFIGS })
export class ReadRecordController {
    constructor(private readonly feature: ReadRecordFeature) {}

    @Menu(ActionType.BROWSE_RECORD, 'onClick')
    public showReadRecord() {
        this.feature.showReadRecord();
    }

    @Menu(ActionType.BROWSE_RECORD, 'shouldHide')
    public shouldHide() {
        return !setDefaultConfig(appConfigInstance.getConfig(ToolbarFileMenuConfig.readRecord as any), true)
        || !SlideDataServices.DocInfoManager()?.isOwner;
    }

    @Menu(ActionType.BROWSE_RECORD, 'shouldDisabled')
    public shouldDisabled() {
        return !SlideDataServices.PrivilegeManager()?.getPrivilegeAttribute().can_view_browsing_history;
    }
}
